
import { z } from "zod";

// Username: 3–50 chars, alphanumeric, dash/underscore, no spaces.
export const usernameSchema = z.string()
  .min(3, "Username must be at least 3 characters")
  .max(50, "Username is too long")
  .regex(/^[a-zA-Z0-9_-]+$/, "Alphanumeric, dashes/underscores only");

// Full name: 1–100 chars, letters, space, some punctuation.
export const fullNameSchema = z.string()
  .min(1, "Full name is required")
  .max(100, "Full name is too long")
  .regex(/^[a-zA-Z\s.'-]+$/, "Full name contains invalid characters");

// Bio: up to 500 characters (optional)
export const bioSchema = z.string()
  .max(500, "Bio is too long")
  .optional();

// Full profile object
export const profileUpdateSchema = z.object({
  username: usernameSchema,
  full_name: fullNameSchema,
  bio: bioSchema,
  avatar_url: z.string().url().optional().nullable(),
});
